import { render, staticRenderFns } from "./SwitchView.vue?vue&type=template&id=46ec2d78&scoped=true&"
import script from "./SwitchView.vue?vue&type=script&lang=js&"
export * from "./SwitchView.vue?vue&type=script&lang=js&"
import style0 from "./SwitchView.vue?vue&type=style&index=0&id=46ec2d78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ec2d78",
  null
  
)

export default component.exports